import { Link } from 'react-router-dom';
import { categories } from '@/mocks/animeData';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">探索分类</h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">六大类型，精准匹配你的口味偏好</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group bg-background-100 rounded-xl p-5 text-center transition-all duration-300 hover:bg-primary-50 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                <i className={`${cat.icon} text-xl text-primary-500 group-hover:text-background-50 transition-colors duration-300`}></i>
              </div>
              <h3 className="font-heading text-sm text-foreground-900 mb-1">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed hidden sm:block">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}